import React from 'react';
import { Routes, Route, Link } from "react-router-dom";
import { Alert, Drawer, DrawerBackdrop, DrawerCloseTrigger, DrawerContent, DrawerDialog } from "@heroui/react";

import Header from "../components/public/Header";
import MainMenu from "../components/public/MainMenu";
import ApiKeysPage from "../components/private/apikeys/ApiKeysPage";
// feat/topics — D47.
import TopicsPage from "../components/private/topics/TopicsPage";
import WebhooksPage from "../components/private/webhooks/WebhooksPage";
import UsersPage from "../components/private/users/UsersPage";
import NotificationsPage from "../components/private/activity/NotificationsPage";
import Footer from "../components/public/Footer";

import CollectionsPage from "../components/private/collections/CollectionsPage"
import CollectionPage from "../components/private/collections/CollectionPage"

import ProfilePage from "../components/private/profile/ProfilePage"
import ToDoAppPage from "../components/private/todo/ToDoAppPage"

import userService from "../services/auth.service"
import { fieldErrorsOf } from "../services/apiClient"
import { messageOf } from "../i18n/el"
import withRouter from "../components/common/withRouter"
import DesignCheck from "./DesignCheck"
import SearchPage from "./SearchPage"
import BackToTop from "../components/common/BackToTop";
import routes from "../routes";
import { countBadges } from "../services/activity.service";
import { getUser, refreshSessionUser } from "../services/session";

// Τα ερευνητικά ενδιαφέροντα γράφονται ως κείμενο χωρισμένο με κόμματα. Ο διαχωρισμός
// γίνεται μόνο στα κόμματα και το trim μόνο στα άκρα κάθε τιμής, ώστε οι πολυλεκτικοί
// όροι να διατηρούν τα εσωτερικά τους κενά.
function parseInterests(text) {
    return text.split(",").map(item => item.trim()).filter(Boolean);
}


/**
 * Κάθε πόσο ρωτιέται το πλήθος των αδιάβαστων (ΚΔ2).
 *
 * **Δέκα δευτερόλεπτα και όχι πέντε**, και το κόστος είναι ο λόγος: με δέκα
 * γίνονται **360 αιτήματα ανά χρήστη ανά ώρα** αντί για 720, και η διαφορά που
 * αντιλαμβάνεται ο χρήστης είναι μερικά δευτερόλεπτα σε **ειδοποίηση**, δηλαδή σε
 * πληροφορία που εξ ορισμού δεν είναι επείγουσα.
 *
 * Ο βρόχος τρέχει **μόνο σε ορατή καρτέλα**, οπότε ο πραγματικός αριθμός είναι
 * κατά πολύ μικρότερος: μετράει ο χρόνος που ο χρήστης κοιτάζει την εφαρμογή, όχι
 * ο χρόνος που είναι συνδεδεμένος.
 */
const UNREAD_INTERVAL = 10000;

class Dashboard extends React.Component {
    
    constructor(props){
        super(props);
        this.state = {
            email: "",
            username: "",
            fullName: "",
            avatar: "",
            interests: [],
            // Το κείμενο που πληκτρολογεί ο χρήστης κρατιέται αυτούσιο και μετατρέπεται
            // σε πίνακα μόνο κατά την υποβολή. Αν η μετατροπή γινόταν σε κάθε πάτημα
            // πλήκτρου, το trim θα έσβηνε το κενό πριν προλάβει να γραφτεί η επόμενη
            // λέξη, και το «computer science» θα κατέληγε «computerscience».
            interestsText: "",
            // sessionError: αποτυχία φόρτωσης του κελύφους. error/successMsg/fieldErrors:
            // μηνύματα της οθόνης προφίλ. Ήταν ένα κοινό κλειδί, οπότε μια αποτυχημένη
            // αποθήκευση προφίλ αποσύνδεε τον χρήστη.
            sessionError: "",
            error: "",
            fieldErrors: {},
            successMsg: "",
            // Ο τίτλος της γραμμής πλοήγησης, όταν τον γνωρίζει μόνο η σελίδα, και η
            // κατάσταση της συλλογής που ανεβαίνει στην ίδια μπάρα αντί να
            // επαναλαμβάνεται μέσα στη σελίδα.
            pageTitle: "",
            pageStatus: null,
            // Το πλαϊνό μενού σε κινητό. Η κατάσταση ανήκει στο κέλυφος, αντί για
            // χειροκίνητες κλάσεις στο <html> όπως στο πρότυπο του 2019.
            isMenuOpen: false,
            // Το συρόμενο μενού δεν αρκεί να κρύβεται με utility: πρέπει να **μην
            // αποδίδεται** σε μεγάλη οθόνη, αλλιώς υπάρχουν δύο μενού στο DOM και
            // το κρυμμένο παραμένει προσβάσιμο με πληκτρολόγιο.
            isDesktop: window.matchMedia('(min-width: 1024px)').matches,
            // P1-7. Το πλήθος των αδιάβαστων ειδοποιήσεων ζει στο κέλυφος και όχι
            // στο μενού: το μενού αποδίδεται δύο φορές (μόνιμο και συρόμενο), και
            // δύο αντίγραφα που φορτώνουν το καθένα το δικό του πλήθος θα έκαναν
            // δύο αιτήματα και θα μπορούσαν να δείχνουν διαφορετικό αριθμό.
            unreadNotifications: 0,
            // ΚΣΤ: η δεύτερη σήμανση. Ζει **δίπλα** στην πρώτη και γεμίζει από
            // την **ίδια** ανάγνωση: δύο ανεξάρτητοι βρόχοι για δύο αριθμούς που
            // εμφανίζονται μαζί θα διπλασίαζαν τα αιτήματα και θα απέκλιναν στην
            // πρώτη διαφορά συμπεριφοράς — ο ένας σταματά σε κρυφή καρτέλα, ο
            // άλλος όχι.
            activeTasks: 0,
            // Αυξάνεται **μόνο** όταν αλλάξει ο καθολικός ρόλος. Δεν είναι
            // δεδομένο της οθόνης: είναι ο τρόπος να ξαναποδοθεί το μενού όταν
            // αλλάξει κάτι που ζει **εκτός** του React.
            roleVersion: 0
        };

        this.desktopQuery = window.matchMedia('(min-width: 1024px)');
        this.handleBreakpoint = (event) => this.setState({
            isDesktop: event.matches,
            // Αλλαγή σε μεγάλη οθόνη με ανοιχτό το συρόμενο θα άφηνε την κατάσταση
            // ανοιχτή σε μενού που δεν αποδίδεται πλέον.
            isMenuOpen: event.matches ? false : this.state.isMenuOpen
        });

        this.handleChange = this.handleChange.bind(this);
        this.resetMessages = this.resetMessages.bind(this);
        this.fetchUserData = this.fetchUserData.bind(this);
        this.userDataUpdate = this.userDataUpdate.bind(this);
        this.handleInterestsChange = this.handleInterestsChange.bind(this);
        this.setInterestsText = this.setInterestsText.bind(this);
        this.setPageTitle = this.setPageTitle.bind(this);
        this.setPageStatus = this.setPageStatus.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
        this.refreshUnread = this.refreshUnread.bind(this);
        this.handleVisibility = this.handleVisibility.bind(this);

        // Ο χρονιστής **δεν είναι κατάσταση**: η αλλαγή του δεν αλλάζει τίποτα
        // στην οθόνη, και μέσα στο `state` θα προκαλούσε άσκοπη επανάποδοση σε
        // κάθε εκκίνηση και παύση.
        this.unreadTimer = null;
    }

    setPageTitle(pageTitle){
        this.setState({ pageTitle });
    }

    setPageStatus(pageStatus){
        this.setState({ pageStatus });
    }

    // Η αποσύνδεση καθαρίζει τη συνεδρία και πλοηγεί με `replace`, ώστε το «πίσω»
    // να μην επιστρέφει σε προστατευμένη οθόνη με άκυρο διακριτικό.
    handleLogout(){
        userService.logout();
        this.props.navigate("/login", { replace: true });
    }

    handleChange(e) {           
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    resetMessages(){
        this.setState({
            error: "",
            fieldErrors: {},
            successMsg :""
        })
    }

    fetchUserData() {
        userService.getCurrentUser()
        .then(
            user => {
              this.setState ({
                username: user.username,
                email: user.email,
                // feat/email-change (ΛΑ-02 / D45): η **μασκαρισμένη** εκκρεμής
                // διεύθυνση, πάντοτε παρούσα στην απόκριση — `null` όταν δεν
                // υπάρχει αίτημα, ώστε ο πελάτης να μη μαντεύει τη μορφή.
                pendingEmail: user.pendingEmail ?? null,
                fullName: user.fullName,
                avatar: user.avatar,
                interests: user.interests ?? [],
                interestsText: (user.interests ?? []).join(", "),
                sessionError: ""
              });
            },
            error => {
                // Αποτυχία δικτύου ή σφάλμα διακομιστή. Το 401 το χειρίζεται ήδη
                // κεντρικά ο apiClient, οπότε εδώ φτάνει μόνο πραγματική βλάβη.
                this.setState({ sessionError : messageOf(error) })
            }
        );
    }

    userDataUpdate(){
        if (!(this.state.fullName)) return;

        this.setState({ error: "", fieldErrors: {}, successMsg: "" });

		let userData = {
			fullName: this.state.fullName,
			avatar: this.state.avatar ? this.state.avatar : null,
			interests: parseInterests(this.state.interestsText)
        }

        userService.updateCurrentUser(userData)
        .then(
          user => {
            this.setState({
                successMsg : "Το προφίλ σας ενημερώθηκε.",
                fullName: user.fullName,
                avatar: user.avatar,
                interests: user.interests ?? [],
                interestsText: (user.interests ?? []).join(", "),
                error: "",
                fieldErrors: {}
            });
        },
        error =>  {
            this.setState({ error : messageOf(error), fieldErrors: fieldErrorsOf(error), successMsg: "" });
        }
      );
    }

    handleInterestsChange(e) {
        this.setState({ interestsText: e.target.value });
    }

    // Η οθόνη προφίλ προσθέτει προτεινόμενα ενδιαφέροντα με πάτημα, οπότε
    // χρειάζεται να θέσει το κείμενο απευθείας και όχι μέσω γεγονότος.
    setInterestsText(interestsText) {
        this.setState({ interestsText });
    }

    // P1-7. Η αποτυχία **δεν ρίχνει την οθόνη**: η σήμανση είναι στοιχείο του
    // κελύφους, και ένα σφάλμα δικτύου δεν πρέπει να διακόψει τον χρήστη. Το
    // σφάλμα εμφανίζεται με μήνυμα μόλις ανοίξει τον κατάλογο.
    //
    // ⚠ **Το 401 όμως ΣΤΑΜΑΤΑΕΙ τον βρόχο.** Δεν είναι παροδική αποτυχία αλλά
    // ληγμένο διακριτικό, και ο πελάτης έχει ήδη τερματίσει τη συνεδρία. Βρόχος
    // που συνεχίζει θα χτυπούσε τον εξυπηρετητή ανά δέκα δευτερόλεπτα με
    // διαπιστευτήριο που ξέρει ότι δεν ισχύει — για πάντα, αν η καρτέλα μείνει
    // ανοιχτή. Κάθε **άλλο** σφάλμα αφήνει τον βρόχο ζωντανό και τον αριθμό στην
    // τελευταία γνωστή τιμή: μια στιγμιαία διακοπή δικτύου δεν είναι λόγος να
    // πάψει η σήμανση να ενημερώνεται μέχρι την επόμενη φόρτωση σελίδας.
    refreshUnread(){
        countBadges().then(
            ({ unread, activeTasks, isAdmin }) => {
                // ⚠ **Η ζωντανή σημαία γράφεται στη ΣΥΝΕΔΡΙΑ, όχι σε κατάσταση
                // αυτού του συστατικού.** Ο καθολικός ρόλος διαβάζεται από
                // **δύο** σημεία —το φίλτρο του μενού εδώ, και ο ρόλος μέσα σε
                // κάθε συλλογή— και το δεύτερο δεν περνά από εδώ. Γραμμένος στη
                // συνεδρία, διορθώνονται **και τα δύο** χωρίς νέα καλωδίωση.
                const roleChanged = refreshSessionUser({ isAdmin });

                this.setState({
                    unreadNotifications: unread,
                    activeTasks,
                    // Η αλλαγή ρόλου πρέπει να **αναγκάσει** νέα απόδοση: το
                    // μενού διαβάζει τη συνεδρία, που δεν είναι κατάσταση του
                    // React και δεν πυροδοτεί τίποτα από μόνη της.
                    roleVersion: roleChanged ? this.state.roleVersion + 1 : this.state.roleVersion
                });
            },
            error => { if (error?.status === 401) this.stopUnreadPolling(); }
        );
    }

    startUnreadPolling(){
        // Ένας χρονιστής, όσες φορές κι αν κληθεί: το `visibilitychange` μπορεί να
        // πυροδοτηθεί διαδοχικά, και δύο χρονιστές διπλασιάζουν τα αιτήματα χωρίς
        // να φαίνεται πουθενά.
        if (this.unreadTimer) return;
        this.unreadTimer = window.setInterval(this.refreshUnread, UNREAD_INTERVAL);
    }

    stopUnreadPolling(){
        if (!this.unreadTimer) return;
        window.clearInterval(this.unreadTimer);
        this.unreadTimer = null;
    }

    // ⚠ **Η ΚΡΥΦΗ ΚΑΡΤΕΛΑ ΔΕΝ ΡΩΤΑΕΙ.** Δέκα ανοιχτές καρτέλες της εφαρμογής θα
    // παρήγαγαν δέκα ρεύματα αιτημάτων για μία σήμανση που **κανείς δεν βλέπει**.
    // Στην επιστροφή γίνεται **άμεση** ανάκτηση και μετά ξαναρχίζει ο βρόχος: ο
    // χρήστης που γυρίζει στην καρτέλα δεν πρέπει να περιμένει έναν πλήρη κύκλο
    // για να δει σωστό αριθμό — θα ήταν χειρότερο από το να μην υπήρχε βρόχος.
    handleVisibility(){
        if (document.visibilityState === 'visible') {
            this.refreshUnread();
            this.startUnreadPolling();
            return;
        }

        this.stopUnreadPolling();
    }

    componentDidMount(){
        this.fetchUserData();
        this.refreshUnread();
        this.desktopQuery.addEventListener('change', this.handleBreakpoint);
        document.addEventListener('visibilitychange', this.handleVisibility);
        // Η εκκίνηση περνά από τον ίδιο έλεγχο ορατότητας: η εφαρμογή μπορεί να
        // φορτώσει σε καρτέλα που άνοιξε στο παρασκήνιο.
        if (document.visibilityState === 'visible') this.startUnreadPolling();
    }

    componentWillUnmount(){
        this.desktopQuery.removeEventListener('change', this.handleBreakpoint);
        document.removeEventListener('visibilitychange', this.handleVisibility);
        // Χωρίς αυτό ο βρόχος επιβιώνει της αποσύνδεσης: το κέλυφος
        // αποπροσαρτάται, ο χρονιστής όχι.
        this.stopUnreadPolling();
    }

    toggleMenu(){
        this.setState(prev => ({ isMenuOpen: !prev.isMenuOpen }));
    }

    closeMenu(){
        this.setState({ isMenuOpen: false });
    }

    render(){
        // P1-8: οι εγγραφές `adminOnly` δεν εμφανίζονται σε μη διαχειριστή. Το
        // `MainMenu` δεν χρειάστηκε να μάθει τον ρόλο: το `Dashboard` είναι ήδη το
        // σημείο που ξέρει ποιος είναι συνδεδεμένος.
        const visibleRoutes = routes.filter((route) => !route.adminOnly || getUser()?.isAdmin);
        const menu = (
            <MainMenu
                routes={visibleRoutes}
                onNavigate={this.closeMenu}
                badges={{
                    unreadNotifications: this.state.unreadNotifications,
                    activeTasks: this.state.activeTasks
                }}
            />
        );

        return (
            // `overflow-x-hidden`: ένα μόνο παιδί που ξεπερνά το πλάτος — μια μεγάλη
            // λέξη, ένας πίνακας, ένα chip — παρήγαγε οριζόντια κύλιση σε **ολόκληρη**
            // τη σελίδα. Το `min-w-0` παρακάτω είναι η άλλη μισή λύση: χωρίς αυτό, ένα
            // παιδί σε flex container δεν συρρικνώνεται κάτω από το εγγενές πλάτος
            // του περιεχομένου του, οπότε σπρώχνει το κέλυφος.
            <div className="flex min-h-screen overflow-x-hidden bg-background">
                {/* Από τα 1024 πίξελ το μενού είναι **μόνιμο** και το συρόμενο δεν
                    αποδίδεται καθόλου: αποδιδόταν πάντοτε, οπότε σε μεγάλη οθόνη
                    υπήρχαν δύο αντίγραφα του μενού στο DOM και το ένα μπορούσε να
                    ανοίξει από πάνω. Κάτω από τα 1024 συμβαίνει το αντίστροφο, γιατί
                    στα 375 πίξελ μια σταθερή στήλη αφήνει ελάχιστο χώρο (ΜΛΑ-11). */}
                <aside className="hidden w-72 shrink-0 lg:block">
                    <div className="fixed inset-y-0 left-0 w-72 overflow-y-auto">{menu}</div>
                </aside>

                {!this.state.isDesktop && (
                    <Drawer isOpen={this.state.isMenuOpen} onOpenChange={(open) => this.setState({ isMenuOpen: open })}>
                        {/* Η σειρά είναι Backdrop → Content → Dialog, και το `placement`
                            ανήκει στο **Content**: αυτό είναι ο περιέκτης τοποθέτησης
                            (`fixed inset-0 flex`), ενώ το Dialog είναι μόνο το φύλλο.
                            Με το `placement` στο Dialog η τοποθέτηση έμενε η
                            προεπιλεγμένη — από κάτω — και το συρόμενο εμφανιζόταν σε
                            λάθος θέση αφήνοντας κενό.

                            Το `p-0` και το `bg-transparent` στο Dialog: φέρνει δικό του
                            padding και λευκή επιφάνεια (`bg-overlay`), που έκοβαν το μωβ
                            μενού και άφηναν λευκό περιθώριο γύρω του. */}
                        <DrawerBackdrop>
                            <DrawerContent placement="left" className="w-72 max-w-[85vw]">
                                <DrawerDialog className="h-full border-0 bg-transparent p-0 shadow-none" aria-label="Κύρια πλοήγηση">
                                    {/* Το Χ κλεισίματος. Χωρίς αυτό το συρόμενο κλείνει
                                        μόνο με Escape ή με πάτημα έξω από αυτό, που
                                        κανένα από τα δύο δεν είναι ορατό στην οθόνη. */}
                                    {/* Τα χρώματα ορίζονται στο `index.css`, όχι εδώ: η
                                        παραλλαγή της βιβλιοθήκης φέρνει δικό της ανοιχτό
                                        γκρι φόντο, που πρέπει να ακυρωθεί και όχι απλώς
                                        να καλυφθεί. Εδώ μένει μόνο η θέση. */}
                                    <DrawerCloseTrigger
                                        aria-label="Κλείσιμο μενού"
                                        className="absolute end-3 top-3 z-10"
                                    >
                                        <i className="fa-solid fa-xmark" aria-hidden="true" />
                                    </DrawerCloseTrigger>
                                    {menu}
                                </DrawerDialog>
                            </DrawerContent>
                        </DrawerBackdrop>
                    </Drawer>
                )}

                <div className="flex min-w-0 flex-1 flex-col">
                    <Header
                        routes={routes}
                        pageTitle={this.state.pageTitle}
                        pageStatus={this.state.pageStatus}
                        user={{
                            fullName: this.state.fullName,
                            username: this.state.username,
                            avatar: this.state.avatar
                        }}
                        onLogout={this.handleLogout}
                        isMenuOpen={this.state.isMenuOpen}
                        onToggleMenu={this.toggleMenu}
                    />

                    <main className="min-w-0 flex-1 px-4 py-6 lg:px-6">
                        {/* Το σφάλμα εμφανίζεται και η περιήγηση παραμένει διαθέσιμη:
                            μια βλάβη δικτύου δεν τερματίζει τη συνεδρία (ΜΛΑ-03) */}
                        {this.state.sessionError &&
                            <Alert status="danger" className="mb-6">
                                <Alert.Indicator />
                                <Alert.Content>
                                    <Alert.Title>Η φόρτωση απέτυχε</Alert.Title>
                                    <Alert.Description>{this.state.sessionError}</Alert.Description>
                                </Alert.Content>
                            </Alert>
                        }

                        <Routes>
                            <Route path="" element={ <CollectionsPage /> } />
                            <Route path="collections/:id" element={ <CollectionPage onTitle={this.setPageTitle} onStatus={this.setPageStatus} /> } />
                            <Route path="todos" element={ <ToDoAppPage /> } />
                            {/* ΛΑ-14 (P1-5): διασυλλογική αναζήτηση πόρων. */}
                            <Route path="search" element={ <SearchPage /> } />
                            {/* P1-8: διαχείριση ανακλητών κλειδιών. Ο έλεγχος ρόλου είναι
                                στον εξυπηρετητή· εδώ μόνο η διαδρομή. */}
                            <Route path="api-keys" element={ <ApiKeysPage /> } />
                            {/* Σετ Γ: Πίνακας 1, `user:manage`. Ο έλεγχος ρόλου είναι
                                στον εξυπηρετητή· εδώ μόνο η διαδρομή. */}
                            <Route path="users" element={ <UsersPage /> } />
                            {/* ΛΑ-27: Πίνακας 1, `integration:manage`. Ο έλεγχος ρόλου
                                είναι στον εξυπηρετητή· εδώ μόνο η διαδρομή. */}
                            <Route path="webhooks" element={ <WebhooksPage /> } />
                            {/* P1-7: ΛΑ-22. Το εύρος είναι ο χρήστης και όχι μια
                                συλλογή, γι' αυτό η οθόνη είναι δική της. */}
                            <Route path="notifications" element={ <NotificationsPage onUnreadChange={this.refreshUnread} /> } />
                            {/* Βιβλιοθήκη συστατικών. Ζει ΜΕΣΑ στο κέλυφος, οπότε το
                                RequireAuth του App.jsx την προστατεύει: δεν είναι
                                προσβάσιμη σε μη συνδεδεμένο χρήστη. */}
                            {/* feat/topics — D47. Το `isAdmin` είναι **ευχρηστία και
                                όχι ασφάλεια**: κρύβει κουμπιά. Ο φράχτης είναι το
                                `topic:manage` του Πίνακα 1, με ζωντανή ανάγνωση της
                                σημαίας στον εξυπηρετητή (D39) — ο υποβιβασμένος
                                διαχειριστής μπορεί να δει τα κουμπιά μέχρι την επόμενη
                                ανανέωση, και **δεν** μπορεί να τα χρησιμοποιήσει. */}
                            <Route path="topics" element={ <TopicsPage isAdmin={Boolean(getUser()?.isAdmin)} /> } />
                            <Route path="design-check" element={ <DesignCheck /> } />
                            <Route path="profile" element={ <ProfilePage {...this.state} userDataUpdate={this.userDataUpdate} fetchUserData={this.fetchUserData}
                                    handleChange={this.handleChange} handleInterestsChange={this.handleInterestsChange}
                                    setInterestsText={this.setInterestsText} resetMessages={this.resetMessages} /> } />
                            <Route path="*" element={ <PageNotFound/> } />
                        </Routes>
                    </main>

                    {/* Α6: **έξω από το `main`, και όχι μέσα του.** Είναι
                        σταθερό ως προς το παράθυρο, οπότε η θέση του δεν
                        εξαρτάται από τη ροή· και μέσα στο `main` θα ήταν το
                        πρώτο πράγμα που συναντά η εστίαση όταν το ίδιο το
                        κουμπί στέλνει την εστίαση εκεί, δηλαδή κύκλος.

                        Ζει στη διάταξη και όχι σε κάθε σελίδα, γιατί το
                        ερώτημα «κύλισε αρκετά;» το απαντά το **παράθυρο** και
                        είναι το ίδιο για όλες. Οι σελίδες που δεν κυλούν δεν
                        πληρώνουν τίποτα: το κουμπί δεν αποδίδεται καθόλου. */}
                    <BackToTop />

                    <Footer />
                </div>
            </div>
            );
    }
}

function PageNotFound() {
    return (
        <div className="flex flex-col items-center justify-center gap-4 py-24 text-center">
            <i className="fa-solid fa-compass text-4xl text-muted" aria-hidden="true" />
            <h2 className="text-xl font-semibold">Η σελίδα δεν βρέθηκε</h2>
            <p className="text-sm text-muted">Ο σύνδεσμος που ακολουθήσατε δεν αντιστοιχεί σε σελίδα.</p>
            {/* Το `Button` του HeroUI 3 είναι το `Button` του React Aria και **δεν
                δέχεται `as`**: τα `as` και `to` αγνοούνταν σιωπηλά, οπότε αποδιδόταν
                κανονικό `<button>` που δεν πλοηγούσε πουθενά. Ο σύνδεσμος παίρνει το
                στυλ του κουμπιού αντί το κουμπί να προσποιείται σύνδεσμο — και
                διατηρεί τη σημασιολογία, δηλαδή μεσαίο κλικ και «άνοιγμα σε νέα
                καρτέλα». */}
            <Link
                to="/"
                className="button button--md button--primary inline-flex items-center gap-2 no-underline"
            >
                Επιστροφή στις συλλογές
            </Link>
        </div>
    )
}

export default withRouter(Dashboard);